module.exports = __webpack_public_path__ + "cabcc3dad417e1c7c9c47aa40531ffc8.svg";